module.exports = __webpack_public_path__ + "static/media/Curtains.0bbfadca.png";